export enum LoginSource {
  Local = import.meta.env.VITE_OIDC_LOGIN_URL,
  Feide = import.meta.env.VITE_OIDC_SERVICE_PROVIDER,
}

export enum LoginName {
  Local = 'local',
  Feide = 'feide',
}
